import type { PricingConfig } from "@photography-booking/shared";
import { Section } from "../components/Section.js";
import { DEFAULT_PRICING } from "../content/site-content.js";
import { formatUsd } from "../content/format.js";

interface InvestmentProps {
  /** Live pricing from the API; defaults to the documented base prices. */
  pricing?: PricingConfig;
}

/**
 * Investment (pricing) section (Req 5.1, 5.2, 5.3):
 *  - full session price + tax
 *  - fine art print price + tax
 *  - typical client spend range
 */
export function Investment({
  pricing = DEFAULT_PRICING,
}: InvestmentProps): JSX.Element {
  return (
    <Section
      id="investment"
      title="Investment"
      subtitle="Transparent pricing, no surprises"
    >
      <div className="investment__cards">
        {pricing.rates.map((rate) => (
          <article className="investment__card" key={rate.label}>
            <h3 className="investment__card-title">{rate.label}</h3>
            <p className="investment__price">
              {formatUsd(rate.hourlyRateCents)}
              <span className="investment__plus-tax"> / hour</span>
            </p>
          </article>
        ))}
      </div>

      <p className="investment__typical">
        Hourly rates by shoot type. Final cost depends on the session length you
        request.
      </p>

      <p className="investment__note">
        Interested in something else? Inquire about other shoot types — product
        ads, cultural or editorial shoots, and more. Please note: boudoir shoots
        are not offered.
      </p>
    </Section>
  );
}
